// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__8z4dz","fadeInKeyframe":"Image_fadeInKeyframe__G1osQ"};